import React from 'react';

export interface FormContainerContentProps extends React.HTMLAttributes<HTMLDivElement> {
    children: React.ReactNode;
}

const FormContainerContent = ({ children, ...rest }: FormContainerContentProps): React.JSX.Element => (
    <div className="content-container" {...rest}>
        {children}
    </div>
);

export default FormContainerContent;
